/**
 * Danh sách ngân hàng Việt Nam
 * Nguồn: Ngân hàng Nhà nước Việt Nam (SBV) + các ngân hàng phổ biến
 */

const VIETNAM_BANKS = [
  // ===== Ngân hàng thương mại Nhà nước =====
  { code: "VCB", shortName: "Vietcombank", name: "Ngân hàng TMCP Ngoại Thương Việt Nam" },
  { code: "VTB", shortName: "VietinBank", name: "Ngân hàng TMCP Công Thương Việt Nam" },
  { code: "BIDV", shortName: "BIDV", name: "Ngân hàng TMCP Đầu Tư và Phát Triển Việt Nam" },
  { code: "AGR", shortName: "Agribank", name: "Ngân hàng Nông Nghiệp và Phát Triển Nông Thôn Việt Nam" },

  // ===== Ngân hàng thương mại cổ phần phổ biến =====
  { code: "TCB", shortName: "Techcombank", name: "Ngân hàng TMCP Kỹ Thương Việt Nam" },
  { code: "MBB", shortName: "MB Bank", name: "Ngân hàng TMCP Quân Đội" },
  { code: "ACB", shortName: "ACB", name: "Ngân hàng TMCP Á Châu" },
  { code: "VPB", shortName: "VPBank", name: "Ngân hàng TMCP Việt Nam Thịnh Vượng" },
  { code: "TPB", shortName: "TPBank", name: "Ngân hàng TMCP Tiên Phong" },
  { code: "STB", shortName: "Sacombank", name: "Ngân hàng TMCP Sài Gòn Thương Tín" },
  { code: "HDB", shortName: "HDBank", name: "Ngân hàng TMCP Phát Triển TP.HCM" },
  { code: "MSB", shortName: "MSB", name: "Ngân hàng TMCP Hàng Hải Việt Nam" },
  { code: "SHB", shortName: "SHB", name: "Ngân hàng TMCP Sài Gòn - Hà Nội" },
  { code: "EIB", shortName: "Eximbank", name: "Ngân hàng TMCP Xuất Nhập Khẩu Việt Nam" },
  { code: "LPB", shortName: "LienVietPostBank", name: "Ngân hàng TMCP Bưu Điện Liên Việt" },
  { code: "OCB", shortName: "OCB", name: "Ngân hàng TMCP Phương Đông" },
  { code: "VIB", shortName: "VIB", name: "Ngân hàng TMCP Quốc Tế Việt Nam" },
  { code: "SSB", shortName: "SeABank", name: "Ngân hàng TMCP Đông Nam Á" },
  { code: "NAB", shortName: "Nam A Bank", name: "Ngân hàng TMCP Nam Á" },
  { code: "BAB", shortName: "Bac A Bank", name: "Ngân hàng TMCP Bắc Á" },
  { code: "SCB", shortName: "SCB", name: "Ngân hàng TMCP Sài Gòn" },
  { code: "ABB", shortName: "ABBank", name: "Ngân hàng TMCP An Bình" },
  { code: "KLB", shortName: "KienLong Bank", name: "Ngân hàng TMCP Kiên Long" },
  { code: "PGB", shortName: "PGBank", name: "Ngân hàng TMCP Xăng Dầu Petrolimex" },
  { code: "VAB", shortName: "VietABank", name: "Ngân hàng TMCP Việt Á" },
  { code: "BVB", shortName: "BaoViet Bank", name: "Ngân hàng TMCP Bảo Việt" },
  { code: "NCB", shortName: "NCB", name: "Ngân hàng TMCP Quốc Dân" },
  { code: "SGB", shortName: "Saigonbank", name: "Ngân hàng TMCP Sài Gòn Công Thương" },
  { code: "PVC", shortName: "PVcomBank", name: "Ngân hàng TMCP Đại Chúng Việt Nam" },
  { code: "VBB", shortName: "VietBank", name: "Ngân hàng TMCP Việt Nam Thương Tín" },
  { code: "GPB", shortName: "GPBank", name: "Ngân hàng TMCP Dầu Khí Toàn Cầu" },
  { code: "CBB", shortName: "CBBank", name: "Ngân hàng TMCP Xây Dựng Việt Nam" },

  // ===== Ngân hàng số / Fintech =====
  { code: "CAKE", shortName: "CAKE", name: "Ngân hàng số CAKE by VPBank" },
  { code: "UBANK", shortName: "Ubank", name: "Ngân hàng số Ubank by VPBank" },
  { code: "TNEX", shortName: "TNEX", name: "Ngân hàng số TNEX by MSB" },
  { code: "TIMO", shortName: "Timo", name: "Ngân hàng số Timo by Ban Viet Bank" },

  // ===== Ngân hàng nước ngoài hoạt động tại VN =====
  { code: "HSBC", shortName: "HSBC", name: "Ngân hàng TNHH MTV HSBC Việt Nam" },
  { code: "SCVN", shortName: "Standard Chartered", name: "Ngân hàng TNHH MTV Standard Chartered Việt Nam" },
  { code: "SHBVN", shortName: "Shinhan Bank", name: "Ngân hàng TNHH MTV Shinhan Việt Nam" },
  { code: "WOO", shortName: "Woori Bank", name: "Ngân hàng TNHH MTV Woori Việt Nam" },
  { code: "CIMB", shortName: "CIMB", name: "Ngân hàng TNHH MTV CIMB Việt Nam" },
  { code: "UOB", shortName: "UOB", name: "Ngân hàng TNHH MTV United Overseas Bank Việt Nam" },
  { code: "KBVN", shortName: "KB Bank", name: "Ngân hàng TNHH MTV KB Kookmin Việt Nam" },
  { code: "IBKVN", shortName: "IBK", name: "Ngân hàng Công nghiệp Hàn Quốc - Chi nhánh HCM" },
  { code: "PBVN", shortName: "Public Bank", name: "Ngân hàng TNHH MTV Public Bank Việt Nam" },

  // ===== Ví điện tử phổ biến (hỗ trợ rút tiền) =====
  { code: "MOMO", shortName: "MoMo", name: "Ví MoMo" },
  { code: "ZALOPAY", shortName: "ZaloPay", name: "Ví ZaloPay" },
  { code: "VNPAY", shortName: "VNPay", name: "Ví VNPay" },
];

export const vietnamBanks = VIETNAM_BANKS;
